module.exports = __webpack_public_path__ + "b16236f4aa307ab0096107113e146474.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/dog-ears-s.png
// module id = 2662
// module chunks = 0